import React from "react";
import Era from "./era";

export default class Eras extends React.Component {
  render() {
    const {eras, data} = this.props;

    return (
      <div className="columns is-centered">
        <div className="column is-two-thirds">
          <div className="columns is-multiline is-mobile">
            {
              eras.map(era => (
                <Era era={era} key={era.fieldValue} data={data} />
              ))
            }
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Eras/index.jsx